import React, { } from 'react'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import { TimelineOppositeContent } from '@mui/lab'
import { Card } from 'src/Common/ui/card'
import { motion } from 'framer-motion'
import { formatDateParts } from 'src/lib/utils'

const VerticalTimelineComponent = ({ timelineType, data, stage = null }) => {
    const timelineVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.1, duration: 0.2, ease: 'easeOut' }
        })
    }
    const connectVariants = {
        hidden: { opacity: 0 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.1, duration: 0.1, ease: 'easeOut' }
        })
    }
    const AnimatedConnector = ({ height, index, delay }) => (
        <>

            <motion.div
                viewport={{ once: true }}
                initial={{ height: 0 }}
                animate={{ height }}
                transition={{ duration: 0.1, delay }}
                style={{ backgroundColor: 'hsl(var(--primary-table-head))', width: 1.5 }}
            />

        </>
    )
    return (
        <Timeline className='!pr-0'>
            {
                data?.map((item, index) => (

                    <TimelineItem className='!min-h-[130px] ' key={index}>
                        <TimelineOppositeContent
                            sx={{ m: 'auto 0', display: 'flex', maxWidth: '29%', justifyContent: 'end' }}
                            align="right"
                            variant="body2"
                        >
                            <motion.div key={index} className='w-full' custom={index} initial="hidden" viewport={{ once: true }} whileInView="visible" variants={timelineVariants}>
                                <div className='flex w-full flex-col content-center '>
                                    {item?.action === 'Created' && <div className='text-primary text-center text-subMenu font-semibold'>Start</div>}
                                    <div className='p-1 text-center text-subMenu font-semibold text-[hsl(var(--timeline-grey))]'>{formatDateParts(item?.timeStamp)?.datePart}</div>
                                    <div className='p-1 text-center text-subMenu font-semibold text-[hsl(var(--timeline-grey))]'>{formatDateParts(item?.timeStamp)?.timePart}</div>
                                    {(item?.action === 'Inprogress' || item?.action === 'End') && <div className='text-pimary text-center text-subMenu font-semibold'>{stage}</div>}

                                </div>
                            </motion.div>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <AnimatedConnector height={index === data?.length - 1 ? '50%' : '100%'} index={index} delay={index * 0.1} />
                        </TimelineSeparator>
                        <TimelineContent sx={{ display: 'flex', alignItems: 'center', position: 'relative', paddingLeft: '28px' }}>

                            <div className='absolute left-[-13px]'>
                                <motion.div className='opacity-0' key={index} custom={index} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={connectVariants}>
                                    <TimelineDot sx={{ background: 'hsl(var(--card))', padding: 0, boxShadow: 'none' }}>
                                        <TimelineDot sx={{ margin: '2px', padding: '2px', background: 'hsl(var(--primary))' }}>
                                            <img style={{ height: '10px', width: '10px' }} src={'/Assets/tickWhite.svg'} alt="ColumFilter.svg" />
                                        </TimelineDot>
                                    </TimelineDot>
                                </motion.div>
                                {/* <div className='w-4 absolute left-2 h-[36px] bg-grcColor'></div> */}
                            </div>
                            <motion.div style={{ width: '85%', height: '100%' }} key={index} custom={index} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={timelineVariants}>
                                <div className='h-full flex items-center'>
                                    <Card className='!w-full flex flex-col justify-center  gap-2 p-[17px]'>
                                        <div className='text-menu text-muted'>{item?.action}</div>
                                        <div className="text-subMenu text-[hsl(var(--timeline-grey))]"><strong>{item?.userName}</strong>{' ' + item?.event}</div>
                                    </Card>
                                </div>
                            </motion.div>
                        </TimelineContent>
                    </TimelineItem>

                ))
            }
        </Timeline>
    )
}

export default VerticalTimelineComponent
